import React from "react";
import {Link} from "react-router-dom";

import "./NavigationLink.css";

function NavigationLink({route, isActive}) {
    const content = (
        <div className={isActive ? "navigationLink activeLink" : "navigationLink inactiveLink" }>
            <div className="navigationIcon">
                {route.icon}
            </div>
            <span>{route.name}</span>
        </div>
    )

    if (route.external) {
        return <a href={route.url} target={route.blank ? "_blank" : null} rel={route.blank ? "noreferrer" : null}>{content}</a>;
    } else {
        return <Link to={route.url}>{content}</Link>;
    }
}

export default NavigationLink;